import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Home = () => {
  const services = [
    {
      title: 'GenAI Evaluation & Testing',
      description:
        'Build automated evaluation pipelines, synthetic datasets, and benchmarking frameworks to ensure your AI systems perform reliably before and after deployment.',
      features: [
        'Automated evaluation pipelines',
        'Synthetic dataset generation',
        'Performance benchmarking & A/B testing',
        'Safety, bias, and hallucination testing',
      ],
      image:
        'https://lh3.googleusercontent.com/aida-public/AB6AXuATbb16Dd4iyieYUV6OrVfBuqQLTlCCVGtcylO9fZ5OF7ioQuDBSxULk1X2NQSDrjq5Gk1yGSfC8dXHnRqsqZCnRwlGcR9e2A0Qy6QsRMqyrQQGN2XliFN64dibQ1a9BdGoUZ0jYTCXfiGPagiYsy5aNoKMnrzTzgRnORYmHF4xey3DfdWsnxXQcj2oj_AspuEYeq7sA1a7mJX1E6O39ZTSf9IW-yeCcho6wrXqWq2khBGeqGU_GII-V1i3xULN1sVVOgBgqn4zxI_0',
    },
    {
      title: 'Prediction & Estimation Models',
      description:
        'Production-ready ML models that predict costs, delivery times, risk, and business outcomes — deployed as APIs processing millions of requests annually.',
      features: [
        'Address prediction & geocoding',
        'Transit time & delivery prediction',
        'Risk classification & mitigation',
        'Customs & regulatory classification',
      ],
      image:
        'https://lh3.googleusercontent.com/aida-public/AB6AXuBYc6RRJFZAK-ffh4rvKYOwAesIiK0kmf2OgvfWsDWZG3fLJ8GkFPZ9NkFsbPm5BrznSylEZNBxnZJRyliPbnz52fXW-EKZrGI-_95pxH-AJBWZQKE5rYHueMMixCHBusjmh6yMTjKlHAys4Q93Tln9JIhvHERKlyxmFs5_qvLxzF_NKX07yyHwpK7Rh-TojN8mIoInA6pRxGKZ8b5YFlMAkmvxBJFf77RNjd0ZPZHOYMU-NhknZztAG2_57dVTufvHugX2Z6UZ7rtF',
    },
    {
      title: 'Agentic AI Systems',
      description:
        'Autonomous agents that execute workflows, trigger actions, and orchestrate tools — like having a tireless team member that handles complex multi-step tasks while you focus on what matters.',
      features: [
        'Multi-step workflow automation',
        'Tool & API orchestration',
        'Event-driven process execution',
        'Autonomous decision-making agents',
      ],
      image:
        'https://lh3.googleusercontent.com/aida-public/AB6AXuCJMYiiEi_tU7vH5yGpoeB41JDvI2wQvPDhYY_6Glqv7gGqYRBlv--m0Jku-5aPVP3ZXtWLcDq6YBBkWtxwWU54Qju3x_0z6SIXlH1Rn7UyBFxNlfWGQy_Aku1756euoWyqBOpXvKsQfH4137TRUFXjXtv_AxHOu22sXDI55P0mo5SqKsUZqYRAEQQk4ov8zSG3ngI5d-G-tSJI80sA5uwVLWveu5bbYyvY2XJLUpFPEhxB6v2jgSEjxKYYB42Sw87IoY27d-E5Xm2M',
    },
    {
      title: 'AI Copilots for Smarter Decisions',
      description:
        'Intelligent assistants that help teams make faster, better-informed decisions — from executive chatbots to procurement evaluation systems that combine rules and AI judgment.',
      features: [
        'Executive chatbots with internal data access',
        'NLP-to-SQL query assistants with RAG',
        'Techno-commercial evaluation systems',
        'Document intelligence & extraction',
      ],
      image:
        'https://lh3.googleusercontent.com/aida-public/AB6AXuCvqe_o8N4Et45gep9dx5WTYIXK2xqUOOKb35HYiSIvgw7HewrqOcg_7WskDZPAqbPmNm9-Svzy3ZVOneSlF42h0BbKONdAH05k1VacG4kX65HgPm1q_Ppyp6_L7lmKA8gHlp9wPlUVtAO_eAGu6lq-egoOpWkyYLGc3t5_K6HAXWjSRteFbBTsTdPBwDGfD5UxYn0pr35P9Il_l96Oy6T91SG97gp8RdeW5DYHtCtNeaiSKTl5TMdFmkt1r9H1ftPjYxpcRz5bbRwr',
    },
  ];

  return (
    <div className="bg-primary">
      {/* Hero Section */}
      <section className="relative flex min-h-[520px] items-center justify-center py-16">
        <div className="absolute inset-0 z-0">
          <img 
            alt="AI abstract background" 
            className="size-full object-cover" 
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuBY_8QiJvtBW0ZkhItucEKKKuA5-q03k0uHU8ZrgzwdS-OREeE-wyN0-z8H4xPho6NG1cO7OtF9GWcOSTdehzFnjhdxu1RGPTbqpjMsYAt_zFQvZQ6zjuoEa1l46zFmDw0xivpcRHc2Rn3hUhCTwtvh3I2J8-yChdtmj_FqYKTxi2YY9ZyTq9rVrv7Oadm8gHjYwk6dSSL8LS_iKLoJD4X2AtBWhhjXcqAAKKU9Xfu8-Np9vjSfgjTX0aeV-yxZDoH4o1QqFVLgzcRW"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary via-primary/80 to-transparent"></div>
        </div>
        <div className="relative z-10 mx-auto max-w-4xl text-center">
          <h1 className="text-white text-6xl font-extrabold leading-tight tracking-tighter md:text-8xl">
            recalibr<span className="text-secondary">.ai</span>
          </h1>
          <div className="mt-6 space-y-2">
            <p className="text-2xl text-text md:text-3xl font-semibold">
              AI implementation that delivers value for business.
            </p>
            <p className="text-lg text-muted md:text-xl">
              Production systems in weeks, not months.
            </p>
          </div>
          <Link
            to="/contact"
            className="mt-10 flex w-[480px] mx-auto cursor-pointer items-center justify-center overflow-hidden rounded-lg h-24 px-8 py-4 bg-secondary text-gray-900 text-lg font-bold leading-snug tracking-[0.015em] transition-all duration-200 hover:bg-cyan-400 hover:scale-105 hover:shadow-lg hover:shadow-secondary/50"
          >
            <span className="truncate">
              Book a Free Consultation!
            </span>
          </Link>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-6xl">
          <h2 className="text-center text-4xl font-bold leading-tight tracking-tighter text-white">
            Implementation Services
          </h2>
          <div className="mt-12 grid gap-8 md:grid-cols-2">
            {services.map((service, index) => (
              <div key={index} className="group relative overflow-hidden rounded-lg bg-gray-800 transition-all duration-300 hover:shadow-2xl hover:shadow-secondary/20">
                <img 
                  alt={service.title} 
                  className="h-64 w-full object-cover transition-transform duration-300 group-hover:scale-105" 
                  src={service.image}
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-white mb-3">{service.title}</h3>
                  <p className="text-muted mb-4">{service.description}</p>
                  <ul className="space-y-2 mb-6">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="text-sm text-muted flex items-start">
                        <span className="text-secondary mr-2">•</span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/contact"
                    className="inline-flex items-center font-semibold text-secondary transition-colors hover:text-blue-500"
                  >
                    Get Started
                    <ArrowRight className="ml-1 h-5 w-5" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
